import { Alert, Col, Tabs } from "antd";
import TopImportantFilters from "./TopImportantFilters";
import { FC } from "react";
import LeftDetailsFilter from "./LeftDetailsFilter";

const { TabPane } = Tabs;

const MobileFilters: FC<{ onFinish: any }> = ({ onFinish }) => {
    return (
        <Col xs={24}>
            <Tabs defaultActiveKey="1">
                <TabPane tab="Sıkça Kullanılan Filtreler" key="1">
                    <Alert message="Filtreler seçim yapıldığında otomatik uygulanır" className="!text-xs sm:!text-sm" type="info"  />
                    <TopImportantFilters isMobile={true} />
                </TabPane>
                <TabPane tab="Detay Filtreleri" key="2">
                    <LeftDetailsFilter isMobile={true} />
                </TabPane>
            </Tabs>
        </Col>
    );
};

export default MobileFilters;
